import type { ApiDrawingDto } from "@/repositories/api.types";
import type { DRDrawing, DRRevision } from "@/types";

/**
 * Utility class for converting API DTOs to domain models
 */
export class DrawingDecoder {
  /**
   * Convert an API drawing DTO to a domain model
   */
  static fromApiDtoToDomain(dto: ApiDrawingDto): DRDrawing {
    const revision: DRRevision = {
      id: dto.lastRevision.id,
      drawingId: dto.id,
      openCloudFileId: dto.lastRevision.openCloudFileId,
      fileId: dto.lastRevision.fileId,
      editedAt: dto.lastRevision.editedAt
        ? new Date(dto.lastRevision.editedAt)
        : undefined,
      savedAt: new Date(dto.lastRevision.savedAt),
      format: dto.lastRevision.format,
      branchId: dto.lastRevision.branchId,
      rasterPaths: dto.lastRevision.rasterPaths,
    };

    return {
      id: dto.id,
      organizationId: dto.organizationId,
      name: dto.fileName,
      initialOpenCloudFileId: dto.initialOpenCloudFileId,
      projectId: dto.project_id,
      createdAt: new Date(dto.createdAt),
      archivedAt: dto.archivedAt ? new Date(dto.archivedAt) : undefined,
      createdBy: dto.createdBy,
      lastRevision: revision,
      branchesCount: dto.branchesCount,
      diagnostic: dto.diagnostic ?? null,
    };
  }
}
